import type { ReactNode } from "react";

export enum AGE_VERIFICATION_STEPS {
  DISCLAIMER = "DISCLAIMER",
  AGE_VERIFICATION = "AGE_VERIFICATION",
}

export enum AGE_VERIFICATION_METHOD {
  DIIA_ASYNC = "diia_async",
  PASS = "portone_async",
}

export type HardAgeVerificationPopupProps = {
  externalContent?: ReactNode;
  logoSrc?: string;
  title: string;
  description?: string;
  continueButtonLabel?: string;
  exitButtonLabel?: string;
  legalNotice?: string;
  alt?: string;
  desktopImageSrc?: string;
  tabletImageSrc?: string;
  mobileImageSrc?: string;
  backButtonLabel?: string;
  verificationTitle?: string;
  mobileQrHelper?: string;
  verificationSteps?: string;
  getNewQrButtonLabel?: string;
  ttlOfCookie?: string;
  logoAlt?: string;
  exitButtonLink?: string;
  qrTtl?: string;
  qrStaleError?: string;
  qrCommonError?: string;
  failedProviderVerificationError?: string;
  shouldRenderOnLogin?: boolean;
  ageVerificationMethod?: AGE_VERIFICATION_METHOD;
  waitingMessage?: string;
  helperText?: string;
  signInButtonLabel?: string;
  tryAgainButtonLabel?: string;
  signInURL?: string;
  verificationErrorHelperText?: string;
  missingDataFromAvError?: string;
  backgroundColor?: string;
  backgroundBlur?: number;
  portalDomNode?: HTMLElement;
  // Change phone number props
  isChangePersonalData?: boolean;
  isPersonalDataUpdatePending?: boolean;
  isOpened?: boolean;
  onClose?: () => void;
  onAgeVerificationSuccess?: () => void | Promise<void>;

  ignoreUrls: string[];
};
